import React from "react";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import { NavItem } from "./sidebarConfig";

interface SidebarNavItemProps {
  item: NavItem;
  isActive: boolean;
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  item,
  isActive,
}) => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const Icon = item.icon;

  const handleClick = () => {
    history.push(`/clients/${id}/${item.path}`);
  };

  return (
    <ListItemButton
      selected={isActive}
      onClick={handleClick}
      sx={{
        padding: "4px 16px",
        gap: "8px",
        borderRadius: "8px",
        "&.Mui-selected": {
          backgroundColor: "rgba(142,66,202,0.08)",
          color: "primary.main",
          "& .MuiListItemIcon-root": {
            color: "primary.main",
          },
          "&:hover": {
            backgroundColor: "rgba(142,66,202,0.12)",
          },
        },
        "&:hover": {
          backgroundColor: "grey.50",
          color: "primary.main",
          "& .MuiListItemIcon-root": {
            color: "primary.main",
          },
        },
      }}
    >
      <ListItemIcon sx={{ minWidth: "unset" }}>
        <Icon size={20} weight="duotone" />
      </ListItemIcon>
      <ListItemText
        primary={item.label}
        primaryTypographyProps={{
          variant: "body2",
          fontWeight: 400,
        }}
      />
    </ListItemButton>
  );
};

export default SidebarNavItem;
